import { FormControl, MenuItem, Select, Box } from '@mui/material';
import { useCallback } from 'react';
import { usePersistedLocale } from '@/i18n/hooks';
import { SUPPORTED_LANGUAGES } from '@/i18n/languages';
import { styled } from '@mui/material/styles';
import { analyticsStyles } from '@/themes/commonStyles/analytics.js';
import { Palette } from '@/themes/themeOverrides/Palette';

const StyledLanguageSwitcher = styled(Box)(() => ({
    ...analyticsStyles.periodInput,
    minWidth: '65px',
    height: '36px',
    backgroundColor: Palette.white,
    '& .MuiFormControl-root': {
        width: '100%',
    },
    '& .MuiSelect-select': {
        fontWeight: '600',
        padding: '5px 14px 5px 12px !important',
    },
}));

const LanguageSwitcher = () => {
    const [locale, setLocale] = usePersistedLocale();

    const handleChange = useCallback(
        event => {
            const nextLocale = event.target.value;
            setLocale(nextLocale);
        },
        [setLocale],
    );

    return (
        <StyledLanguageSwitcher className='period-form'>
            <FormControl className='period-form'>
                <Select id='language-switcher' value={locale} onChange={handleChange}>
                    {SUPPORTED_LANGUAGES.map(language => (
                        <MenuItem key={language.code} value={language.code}>
                            {language.nativeLabel}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </StyledLanguageSwitcher>
    );
};

export default LanguageSwitcher;
